// frontend/src/homepage/fieldDeck.js
//
// The shuffled circular deck the mesh's ignite tags draw professions from.
//
// WHY NOT JUST `fields[Math.floor(random() * fields.length)]`. Independent draws
// repeat: over 15 items the chance of an immediate repeat is 1 in 15 per tag,
// and a visitor watching the hero for a minute WILL see the same profession
// named twice in a row and read the page as broken. A shuffled deck dealt to
// exhaustion guarantees every profession appears once before any appears twice,
// which is what the page is actually claiming - that it matches all of them.
//
// Framework-free and RNG-injectable so the exhaustion property can be tested
// rather than assumed.

/**
 * Fisher-Yates, on a copy. Unbiased: each of the n! orderings is equally likely,
 * which the naive `sort(() => random() - .5)` is not.
 *
 * @param {any[]} items
 * @param {() => number} random
 * @returns {any[]} a new shuffled array.
 */
export function shuffle(items, random = Math.random) {
  const out = items.slice();
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1));
    const swap = out[i];
    out[i] = out[j];
    out[j] = swap;
  }
  return out;
}

/**
 * A deck that deals every item once, then reshuffles and deals again.
 *
 * @param {any[]} items
 * @param {() => number} [random]
 * @returns {{ next: () => any, remaining: () => number }}
 */
export function createFieldDeck(items, random = Math.random) {
  const source = Array.isArray(items) ? items.filter((item) => item != null) : [];
  let deck = [];

  return {
    next() {
      if (source.length === 0) return null;
      if (deck.length === 0) deck = shuffle(source, random);
      return deck.pop();
    },
    remaining: () => deck.length,
  };
}
